import { render, staticRenderFns } from "./OrderSelect.vue?vue&type=template&id=3137c3a6&scoped=true"
import script from "./OrderSelect.vue?vue&type=script&lang=js"
export * from "./OrderSelect.vue?vue&type=script&lang=js"
import style0 from "./OrderSelect.vue?vue&type=style&index=0&id=3137c3a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137c3a6",
  null
  
)

export default component.exports